export default __webpack_public_path__ + "static/media/cash_in_transit.e5e08883.svg";